import * as React from "react";
import { FormGroup, LoadingSpinner } from "@velaro/velaro-component-lib";
import useApi from "@/hooks/useApi";
import { SiteContext } from "@/context/SiteContext";

export default function MessagingSetup() {
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState("");
  const { site } = React.useContext(SiteContext);
  const api = useApi();

  React.useEffect(() => {
    // Auto-initialize on mount
    handleSetup();
  }, []);

  async function handleSetup() {
    setSaving(true);
    setError("");

    try {
      // Create messaging tenant using the company name from site
      const resp = await api.messaging.post("Tenant", {
        companyName: site.companyName || "My Company"
      });

      if (!resp.ok) {
        const errorData = await resp.json();
        setError(errorData.message || "Failed to initialize messaging service");
        setSaving(false);
        return;
      }

      // Redirect to messaging home after successful setup
      window.location.href = "/deployment";
    } catch (err: any) {
      setError(err.message || "An unexpected error occurred");
      setSaving(false);
    }
  }

  if (saving) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <LoadingSpinner />
        <p className="mt-4 text-lg">Initializing messaging service...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="max-w-md p-6 bg-red-50 border border-red-200 rounded">
          <h2 className="text-xl font-bold text-red-800 mb-2">Setup Failed</h2>
          <p className="text-red-700 mb-4">{error}</p>
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-cornflower-blue-500 hover:bg-cornflower-blue-600 rounded-lg transition-colors"
            onClick={handleSetup}
          >
            Retry Setup
          </button>
        </div>
      </div>
    );
  }

  return null;
}
